module.exports = __webpack_public_path__ + "img/4-icono-enproceso-selected.6a7195b2.svg";